var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.flag)?_c('div',{staticClass:"order-mask",on:{"click":function($event){$event.stopPropagation();return _vm.handleRefund.apply(null, arguments)}}},[_c('div',{staticClass:"mask-main"},[_c('img',{attrs:{"src":_vm.imgurl + _vm.data.url,"alt":""},on:{"click":function($event){return _vm.CopyImg(_vm.data.url)}}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }